@layer component {
  .wrapper {
    container-type: inline-size;
    container-name: brandedfooter;
  }

  .container {
    flex-direction: column-reverse;
    font-size: var(--n-font-size-350);
    border-top: 1px solid var(--n-color-border-neutral-subtle);
  }

  @container brandedfooter (width >= 768px) {
    .container {
      flex-direction: row;
    }
  }

  .legal {
    align-items: center;
    justify-content: center;
    letter-spacing: 0.03px;
    width: auto;

    @media (--mq-md) {
      justify-content: center;
    }
  }

  .poweredBy {
    flex-shrink: 0;
    display: inline-flex;
    gap: var(--n-scale-200);
    align-items: center;
    color: inherit;
    text-decoration: none;
    font-weight: var(--n-font-weight-700);
  }

  .narvarIconDark {
    --n-icon-narvar-background: var(--n-color-content-contrast);
    --n-icon-narvar-outline: var(--n-color-content-contrast);
    --n-icon-narvar-n: var(--n-color-white);
  }
}
